//#region src/utils/getWidthInBoundaries.ts
var e = (e, t, n) => n > 0 && n < e ? e : n > 0 && n > t || n > 0 && n > t ? t : n;
//#endregion
export { e as default };

//# sourceMappingURL=getWidthInBoundaries.js.map